module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/foreground_desktop-0e48dadaa469aae64067ad1d1aa4feae.png";